// src/services/zoomService.js
import api from './api';

const zoomService = {
  getConnectUrl: async () => {
    const res = await api.get('/v1/zoom/connect');
    return res.data?.data?.url;
  },

  // Fixed path to Zoom disconnect endpoint
  disconnect: async () => {
    const res = await api.post('/v1/zoom/disconnect');
    return res.data;
  },

  getMeetings: async (params = {}) => {
    const res = await api.get('/v1/zoom/meetings', { params });
    return res.data;
  },

  importMeeting: async (meetingId) => {
    const res = await api.post('/v1/zoom/import', { meetingId });
    return res.data;
  }
};

export default zoomService;